//#region src/core/i18n/locales/sk.ts
var sk_default = {
	buttons: {
		play: "Prehrať",
		pause: "Pozastaviť",
		replay: "Prehrať znova",
		mute: "Stlmiť",
		unmute: "Zrušiť stlmenie"
	},
	seek: {
		forward: "Posunúť dopredu o {seconds} s",
		backward: "Posunúť dozadu o {seconds} s"
	},
	fullscreen: {
		enter: "Režim celej obrazovky",
		exit: "Zavrieť celú obrazovku"
	},
	captions: {
		enable: "Zapnúť titulky",
		disable: "Vypnúť titulky"
	},
	pip: {
		enter: "Obraz v obraze",
		exit: "Zavrieť obraz v obraze"
	},
	live: {
		playing: "Prehráva sa naživo",
		seekToEdge: "Prejsť na živé vysielanie",
		badge: "Naživo"
	},
	cast: {
		start: "Spustiť prenos",
		stop: "Zastaviť prenos",
		connecting: "Pripájam"
	},
	airplay: {
		start: "Spustiť AirPlay",
		stop: "Zastaviť AirPlay"
	},
	slider: { seek: "Posun" },
	time: {
		current: "Aktuálny čas",
		duration: "Čas trvania",
		remaining: "Zostávajúci čas",
		elapsedSuffix: "{duration} uplynulého času",
		durationSuffix: "{duration} trvania",
		remainingSuffix: "Zostáva {duration}",
		showElapsed: "Zobraziť uplynulý čas, {duration}.",
		showDuration: "Zobraziť trvanie, {duration}.",
		showRemaining: "Zobraziť zostávajúci čas, {duration}.",
		toggleElapsed: "Prepínanie medzi uplynulým a zostávajúcim časom.",
		toggleDuration: "Prepínanie medzi trvaním a zostávajúcim časom.",
		position: "{current} z {duration}",
		unknown: "Médium sa nenačítalo, čas nie je známy."
	},
	playback: { rate: "Rýchlosť prehrávania {rate}" },
	volume: {
		mutedValue: "{percent}, stlmené",
		muted: "Stlmené",
		label: "Hlasitosť",
		value: "Hlasitosť {value}"
	},
	status: {
		captionsOn: "Popisky zapnuté",
		captionsOff: "Popisky vypnuté",
		paused: "Pozastavené",
		playing: "Prehráva sa",
		fullscreen: "Celá obrazovka",
		pip: "Obraz v obraze",
		exitPip: "Zavrieť obraz v obraze",
		seekedTo: "Presunuté na {time}"
	},
	container: { label: "Prehrávač médií" },
	errors: {
		aborted: "Prerušili ste prehrávanie",
		network: "Sťahovanie súboru bolo zrušené pre chybu na sieti.",
		decode: "Prehrávanie súboru bolo prerušené pre poškodené dáta, alebo súbor používa vlastnosti, ktoré váš prehliadač nepodporuje.",
		source: "Súbor sa nepodarilo načítať pre chybu servera, sieťového pripojenia, alebo je formát súboru nepodporovaný.",
		encrypted: "Súbor je zašifrovaný a nie je k dispozícii kľúč na rozšifrovanie.",
		unplayable: "Toto médium prehrávač nepodporuje.",
		title: "Niečo sa pokazilo.",
		unexpected: "Vyskytla sa chyba. Skúste to znova."
	},
	common: {
		empty: "",
		ok: "Zatvoriť"
	},
	menu: {
		settings: "Nastavenia",
		quality: "Kvalita",
		audio: "Zvuk",
		default: "Predvolené",
		speed: "Rýchlosť",
		captions: "Titulky",
		playbackRate: "Rýchlosť prehrávania",
		back: "Späť",
		off: "Vypnuté",
		auto: "Automaticky",
		autoWithLabel: "Automaticky ({label})",
		subtitles: "Titulky"
	}
};
//#endregion
export { sk_default as default };

//# sourceMappingURL=sk.js.map